import { useState } from "react";
import { Puzzle, Facebook, Instagram, Mail } from "lucide-react";
import { scrollToId } from "@/components/Shared";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Footer = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const links = [
    { label: "Privacy Policy", action: () => setPrivacyOpen(true), testId: "footer-privacy" },
    { label: "Contact", action: () => scrollToId("#contact"), testId: "footer-contact" },
    { label: "Enrollment", action: () => scrollToId("#enrollment"), testId: "footer-enrollment" },
    { label: "Parent Information", action: () => scrollToId("#parent-info"), testId: "footer-parent-info" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-deepteal-dark text-amber-100/80">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-400 text-deepteal-dark">
                <Puzzle className="h-6 w-6" strokeWidth={1.8} />
              </div>
              <div>
                <p className="font-serif text-lg font-semibold text-amber-50">Pieces to Our Puzzle Childcare</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-300/70">Halethorpe, Maryland</p>
              </div>
            </div>
            <ul className="mt-6 space-y-1.5 text-sm">
              <li data-testid="footer-tagline-ages">Serving Children Ages 2–12</li>
              <li data-testid="footer-tagline-hours">Open 7 Days a Week | 6:00 AM–6:00 PM</li>
              <li>Phone: (410) 900-3947</li>
              <li>Email: Breland7490@gmail.com</li>
            </ul>
            <div className="mt-6 flex gap-3">
              <a data-testid="social-facebook" href="#" aria-label="Facebook (coming soon)" className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-100/20 text-amber-100/70 transition-all duration-300 hover:border-amber-300 hover:text-amber-300">
                <Facebook className="h-4 w-4" />
              </a>
              <a data-testid="social-instagram" href="#" aria-label="Instagram (coming soon)" className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-100/20 text-amber-100/70 transition-all duration-300 hover:border-amber-300 hover:text-amber-300">
                <Instagram className="h-4 w-4" />
              </a>
              <a data-testid="social-email" href="mailto:Breland7490@gmail.com" aria-label="Email us" className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-100/20 text-amber-100/70 transition-all duration-300 hover:border-amber-300 hover:text-amber-300">
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amber-300/80">Quick Links</p>
            <ul className="mt-5 space-y-2.5">
              {links.map((l) => (
                <li key={l.testId}>
                  <button data-testid={l.testId} onClick={l.action} className="text-sm hover:text-amber-300 transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amber-300/80">Programs</p>
            <ul className="mt-5 space-y-2.5 text-sm">
              <li>Childcare · Ages 2–5</li>
              <li>School-Age Care · Ages 6–12</li>
              <li>Before & After School Care</li>
              <li>Weekend Childcare</li>
              <li>Homework Support</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center gap-3 border-t border-amber-100/10 pt-8 text-center">
          <p className="text-xs text-amber-100/50">
            © {new Date().getFullYear()} Pieces to Our Puzzle Childcare · Halethorpe, Maryland · Childcare for ages 2–12, open 7 days a week
          </p>
          <p className="font-serif italic text-sm text-amber-200/70">
            "Every child is an important piece of our puzzle."
          </p>
        </div>
      </div>

      <Dialog open={privacyOpen} onOpenChange={setPrivacyOpen}>
        <DialogContent data-testid="privacy-dialog" className="max-w-lg bg-parchment">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-deepteal-dark">Privacy Policy</DialogTitle>
            <DialogDescription className="text-sm text-slate-600 leading-relaxed pt-2">
              Pieces to Our Puzzle Childcare respects your family's privacy. Information submitted
              through our website forms (such as your name, contact details, and child's age) is used
              only to respond to your inquiry, discuss enrollment, and schedule tours. We do not sell,
              share, or rent your information to third parties. Please do not submit sensitive medical
              or financial information through website forms. To request removal of your information,
              contact us at Breland7490@gmail.com or (410) 900-3947.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default Footer;
